import React from 'react';
import type { ratioTypes } from 'components/components/MBImage/MBImage.types';
import type { IconType } from 'components/CustomIcon/CustomIcon.config';
import type { ProductInfoProps } from 'components/Elements';

export interface TopInfoItem {
  iconName?: IconType;
  label: string;
  bgColor?: string;
  textColor?: string;
}
export interface ProjectProps {
  label: string;
  id: number;
  isLoading?: boolean;
  isAddedToCart?: boolean;
  isActive?: boolean;
}

export type ExtraProductInfo = ProductInfoProps[];

export type ProductCardActionType = 'addToCart' | 'link' | 'customAction';

export type ColorVariant = {
  entity_id: string;
  exact_color: string;
  image_url: string;
  is_unavailable: boolean;
};

export type ProductCardProps = {
  onClickAddToFavorites?: () => void;
  onCreateProject?: () => void;
  onAddToBag?: (id?: number | null) => void;
  onProjectClick?: (id?: number | null) => void;
  onProductClick?: (id?: string, isFromVariantsClick?: boolean) => void;
  onSelected?: (value?: boolean) => void;
  onRightClick?: () => void;
  onActionButtonClick?: () => void;
  isOutlined?: boolean;
  isHoverAllowed?: boolean;
  childrenNumber?: string | number;
  entityId?: string | number;
  aspectRatio?: ratioTypes | number;
  imageDecodeMode?: 'eager' | 'lazy';
  topInfoItems?: TopInfoItem[];
  projects?: ProjectProps[];
  selectedProject: ProjectProps | null;
  extraInfo?: ExtraProductInfo;
  showHoverFeatures?: boolean;
  showFeatures?: boolean;
  showSelect?: boolean;
  showSelectOnHover?: boolean;
  showContainedInfo?: boolean;
  showBag?: boolean;
  showExtraInfo?: boolean;
  isSelected?: boolean;
  isOvernight?: boolean;
  label?: string;
  blurhash?: string;
  imageUrl: string;
  productUrl?: string;
  title: string;
  features?: string[];
  isAddToCartLoading?: boolean;
  isAddedToCart?: boolean;
  isAddToFavoritesLoading?: boolean;
  shouldAlwaysShowFavoritesButton?: boolean;
  shouldAlwaysShowContainedCartButton?: boolean;
  disabled?: boolean;
  actionsButtons?: React.ReactNode;
  afterLabel?: string;
  showProjectsDropdown?: boolean;
  isMobileDevice?: boolean;
  isSmallDesktop?: boolean;
  showAdvancedInfo?: boolean;
  centerAdvancedInfo?: boolean;
  subtitle1?: string;
  subtitle2?: string;
  categoryName?: string;
  brandName?: string;
  actionType?: ProductCardActionType;
  actionButtonText?: string;
  hideActionButton?: boolean;
  addToCartLabel?: string;
  addToCartHoverLabel?: string;
  addToCartTooltipLabel?: string;
  addedToCartLabel?: string;
  createProjectButtonLabel?: string;
  inStockLabel?: string;
  outOfStockLabel: string;
  projectPreLabel?: string;
  saveButtonLabel?: string;
  isCompactDescription?: boolean;
  showOnHoverOnlyOvernight?: boolean;
  searchPlaceholderLabel?: string;
  withColorVariants?: boolean;
  isDigital?: boolean;
  digitalCatalogLabel?: string;
  colorVariants?: ColorVariant[];
  colorVariantsNumber?: number;
  activeVariantId?: string;
  onVariantClick?: (item: ColorVariant) => void;
  onVariantLeftClick?: () => void;
  tooltipTitle?: string;
  isSelectboxDisabled?: boolean;
  checkboxTooltipTitle?: string;
  shouldHideFavoritesButton?: boolean;
  customTopRightButtonCallback?: (value?: string) => void;
};

export enum ProjectDropdownVariant {
  GHOST = 'GHOST',
  CONTAINED = 'Contained',
}

export enum ProjectDropdownVariantsEnum {
  FULL_SELECT = 'full_select',
  DROPDOWN_ONLY = 'dropdown_only',
}

export interface ProjectDropdownProps {
  entityId?: string | number;
  shouldShow: boolean;
  selectedProject: ProjectProps | null;
  onAddToBag?: (id?: number | null) => void;
  onProjectClick?: (id?: number | null) => void;
  projects: ProjectProps[];
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
  onCreateProject?: () => void;
  isContained: boolean;
  isAddToCartLoading?: boolean;
  showExtraInfo?: boolean;
  preLabel?: string;
  variant?: ProjectDropdownVariant;
  hideAddToBag?: boolean;
  isAddedToCart?: boolean;
  maxWidth?: number;
  className?: string;
  dropdownClassName?: string;
  dropdownVariant?: ProjectDropdownVariantsEnum;
  createProjectButtonLabel?: string;
  searchPlaceholderLabel?: string;
  minWidth?: number;
}
